import { Loading } from 'design-system-web';

export default Loading;
